export const trim = (value : any) => value ? value.trim() : '';
export const keepEmpty = (value : any) => value ? value : '';
